import { Grid } from '@mui/material';
import DataItem from './DataItem';

interface IProps {
  eventDates?: string;
  eventId?: string;
  userName?: string;
}

function EventCompletionInfoSubHeader({
  eventDates,
  eventId,
  userName,
}: IProps) {
  return (
    <Grid container>
      <Grid item xs={12} md={4}>
        <DataItem title='DATE(S):' data={eventDates} />
      </Grid>
      <Grid item xs={12} md={4}>
        <DataItem title='EVENT ID:' data={eventId} />
      </Grid>
      <Grid item xs={12} md={4}>
        <DataItem title='SUBMITTED BY:' data={userName} />
      </Grid>
    </Grid>
  );
}

export default EventCompletionInfoSubHeader;
